import "./datenschutz.css";
import { useEffect } from "react";

export default function Datenschutz() {
  useEffect(() => {
    // Beim Laden der Seite nach oben scrollen
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="datenschutz">
      <br />
      <br />
      <h1>Datenschutz</h1>

      <p>
        Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
      </p>

      <h2>1. Erhebung und Verarbeitung personenbezogener Daten</h2>
      <p>
        Personenbezogene Daten werden nur erhoben, wenn Sie uns diese von sich aus, z. B. zur Kontaktaufnahme, freiwillig mitteilen. Dies kann z. B. über unser Kontaktformular oder per E-Mail geschehen.
      </p>

      <h2>2. Nutzung und Weitergabe personenbezogener Daten</h2>
      <p>
        Ihre personenbezogenen Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. Eine Weitergabe kann nur erfolgen, soweit dies gesetzlich vorgeschrieben ist oder der Schutz unserer Rechte dies erfordert.
      </p>

      <h2>3. Datensicherheit</h2>
      <p>
        Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre durch uns verwalteten Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder Zugriff unberechtigter Personen zu schützen. Trotz aller Sicherheitsmaßnahmen kann die Datenübertragung im Internet (z. B. bei E-Mail-Kommunikation) Sicherheitslücken aufweisen.
      </p>

      <h2>4. Cookies</h2>
      <p>
        Auf unserer Website werden Cookies eingesetzt. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden. Sie dienen dazu, die Nutzung unserer Website komfortabler zu gestalten. Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihres Browsers verhindern; wir weisen jedoch darauf hin, dass in diesem Fall gegebenenfalls nicht alle Funktionen dieser Website vollumfänglich genutzt werden können.
      </p>

      <h2>5. Nutzung von Google Fonts / externen Diensten</h2>
      <p>
        Sofern auf unserer Website externe Dienste wie Google Fonts eingebunden werden, geschieht dies auf Grundlage Ihres berechtigten Interesses, ein ansprechendes Design zu gewährleisten. Bitte beachten Sie die jeweiligen Datenschutzerklärungen der Drittanbieter.
      </p>

      <h2>6. Verwendung der Kontaktdaten</h2>
      <p>
        Die im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten dürfen von Dritten nicht für die Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien genutzt werden. Die Betreiber behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.
      </p>

      <h2>7. Ihre Rechte</h2>
      <p>
        Sie haben das Recht auf Auskunft über die zu Ihrer Person gespeicherten Daten sowie ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten wenden Sie sich bitte an die im Impressum angegebenen Ansprechpartner.
      </p>

      <h2>8. Änderungen der Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Dienstleistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
      </p>
    </section>
  );
}
